import React from "react";
import { ReactComponent as NoFoundImg } from "../../../assets/illustrations/404-240x240.svg";
import ServicesLayout from "../../../layouts/Services.layout";

export const LinkExpiredPage: React.FC = () => {
  return (
    <ServicesLayout image={<NoFoundImg />} title="This link has expired">
      <div className="text-base theme-text-secondary">
        Sorry, this link expires to keep our service secure
      </div>
    </ServicesLayout>
  );
};
